import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from "@mui/material";
import LogoutIcon from "@mui/icons-material/Logout";
import SwapHorizIcon from "@mui/icons-material/SwapHoriz";
import { useAppTheme } from "../../../context/theme.context";

const LogoutDialog = ({ open, onClose, onSwitchUser, onSignOut }) => {
  const { colors, isDark } = useAppTheme();

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="xs"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: 2,
          backgroundColor: colors.surface || "#fff",
          backgroundImage: "none",
        },
      }}
    >
      <DialogTitle sx={{ fontWeight: 700 }}>¿Qué querés hacer?</DialogTitle>
      <DialogContent>
        <Typography variant="body2" color="text.secondary">
          Tu cuenta tiene acceso a más de un tipo de usuario. Podés cambiar de
          usuario o cerrar sesión.
        </Typography>
      </DialogContent>
      <DialogActions
        sx={{
          p: 2,
          pt: 0,
          gap: 1,
          flexDirection: isDark ? "column" : "row",
        }}
      >
        <Button
          variant="outlined"
          color="primary"
          fullWidth
          startIcon={<SwapHorizIcon />}
          onClick={onSwitchUser}
          sx={{ textTransform: "none" }}
        >
          Cambiar de usuario
        </Button>
        <Button
          variant="contained"
          color="error"
          fullWidth
          startIcon={<LogoutIcon />}
          onClick={onSignOut}
          sx={{ textTransform: "none" }}
        >
          Cerrar sesión
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default LogoutDialog;
